<!-- @prettier -->
<template>
  <div>
    <Hero title="Brauchst du Hilfe?" />
    <section class="container content">
      <div class="breadcrumb d-flex">
        <div class="flex-grow-1">
          <nuxt-link :to="localePath('/')">Home</nuxt-link>
          <span class="breadcrumb--separator">></span>
          {{ $t('Hilfe') }}
        </div>
      </div>

      <missingLocale v-if="$i18n.locale == 'fr'" />

      <h2>Hallo, wie können wir dir heute helfen?</h2>
      <p>
        Willkommen auf der Hilfe-Seite von Lernpfad. Hier findest du kurze
        Erklärungen, welche dir helfen sollen, alles aus Lernpfad herauszuholen.
      </p>

      <b-row>
        <b-col
          cols="12"
          lg="6"
        >
          <Vimeo video-id="514330603" />
          <h3 class="helpTitle">Lernpfad teilen</h3>
          <p class="helpText">
            Lernpfade lassen sich ganz einfach mit Lernenden teilen. Wie das
            funktioniert und warum du nicht noch zuerst eine Menge Accounts
            anlegen musst, zeigen wir dir in diesem Video.
          </p>
        </b-col>

        <b-col
          cols="12"
          lg="6"
        >
          <Vimeo video-id="514314952" />
          <h3 class="helpTitle">Formatierungen in einem Lernschritt</h3>
          <p class="helpText">
            Texte in Lernschritten können auch formatiert werden. Weil es bei
            uns etwas anders läuft als in Word, zeigen wir dir in diesem Video
            welche Möglichkeiten du bei der Gestaltung hast.
          </p>
        </b-col>

        <b-col
          cols="12"
          lg="6"
        >
          <Vimeo video-id="516586754" />
          <h3 class="helpTitle">Individuelle Rückmeldungen geben</h3>
          <p class="helpText">
            Du möchtest deinen Schüler*innen individuelle Feedbacks geben? Kein
            Problem, in diesem Video zeigen wir dir, wie das geht.
          </p>
        </b-col>

        <b-col
          cols="12"
          lg="6"
        >
          <Vimeo video-id="516586803" />
          <h3 class="helpTitle">Den Überblick behalten</h3>
          <p class="helpText">
            In der Alltagshektik den Überblick über den Bearbeitungsfortschritt
            einzelner Lernenden behalten? Klar geht das. Wir verraten dir im
            folgenden Video wie dich Lernpfad dabei unterstützt.
          </p>
        </b-col>

        <b-col
          cols="12"
          lg="6"
        >
          <Vimeo video-id="516594186" />
          <h3 class="helpTitle">Benachrichtigungen erhalten</h3>
          <p class="helpText">
            Du möchtest auf dem Laufenden bleiben ohne ständig ein
            Browserfenster offen zu haben? Dann lass dich via E-Mail über
            Aktivitäten deiner Lernenden benachrichtigen. Wir zeigen dir, wie
            das geht.
          </p>
        </b-col>

        <b-col
          cols="12"
          lg="6"
        >
          <Vimeo video-id="" />
          <h3 class="helpTitle">Weitere Videos folgen bald ...</h3>
          <p class="helpText">
            Hast du einen Tipp, welches Funktion wir als nächstes erklären
            sollen? Dann
            <a href="mailto:info@lernpfad.ch">melde dich</a>
            bei uns!
          </p>
        </b-col>

        <p>
          Antworten auf oft gestellte Fragen findest du in unserem
          <a href="https://lernpfad.ch/pfad/gzyecbbg0xn0/">FAQ-Lernpfad.</a>
        </p>
      </b-row>
    </section>
  </div>
</template>

<script>
import Hero from '../components/ui/Hero'
import Vimeo from '../components/ui/Vimeo'
import { ampli } from '../mixins/Amplitude/index.js'
import missingLocale from '../components/locales/missing_locale.vue'

export default {
  nuxtI18n: {
    paths: {
      fr: '/aide',
    },
  },
  components: {
    Hero,
    Vimeo,
    missingLocale,
  },

  mixins: [ampli],

  head() {
    return {
      title: this.$i18n.t('Hilfe | Lernpfad'),
    }
  },

  created() {
    ampli.helpPageViewed()
  },
}
</script>

<style
  scoped
  lang="scss"
>
@import '../assets/style/utils';
.content,
::v-deep .content {
  margin-top: 5em;

  h2 {
    margin: 2rem 0 1rem 0;
    @include fontSizeLineHeight(35px, 66px);
  }

  h3 {
    margin: 2rem 0 1rem 0;
    @include fontSizeLineHeight(22px, 66px);
  }

  .helpTitle {
    margin-top: calculateRem(20px);
  }

  .helpText {
    margin-top: calculateRem(15px);
    margin-bottom: calculateRem(60px);
  }
}
</style>
